module.exports = __webpack_public_path__ + "media/images/social-share-button/linkedin-96905a0a4097dc978626b8bac07960a1.svg";